<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-12 20:10:46
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 16:25:12
-->
<template>
  <ux-form
    ref="form"
    :data="formData"
    width="440px"
    :colon="true"
    :rules="rules"
    label-width="56px"
  >
    <ux-form-item :label="$t('HT.apiList.group')" prop="groupId">{{ data1.name }}</ux-form-item>
    <ux-form-item :label="$t('HT.debug3.domain')" prop="domain">{{ formData.domain }}</ux-form-item>
    <ux-form-item :label="$t('HT.addAccessApi.evn')" prop="envs">
      <ux-checkbox v-model="formData.envs" :options="$opt.env2"></ux-checkbox>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data1: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: {
        name: this.data1.name,
        id: this.data1.id, // 分组id
        domain: this.data.domain, // 域名
        envs: this.data.envs // 环境
      },
      rules: this.$rul.bindDomain()
    };
  }
};
</script>

<style lang="scss" scoped></style>
